import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';
import moment from "moment";

const LOADER_TIEMPOS_CONSULTA = 'LOADER_TIEMPOS_CONSULTA';
const SET_DATA_TIEMPOS_CONSULTA = 'SET_DATA_TIEMPOS_CONSULTA';
const SET_PAGE_TIEMPOS_CONSULTA = 'SET_PAGE_TIEMPOS_CONSULTA';
const SET_BUSCADOR_TIEMPOS_CONSULTA = 'SET_BUSCADOR_TIEMPOS_CONSULTA';
const SET_FILTRO_TIEMPOS_CONSULTA = 'SET_FILTRO_TIEMPOS_CONSULTA';
const SET_INICIAL_DATE_TIEMPOS_CONSULTA = 'SET_INICIAL_DATE_TIEMPOS_CONSULTA';
const SET_FINAL_DATE_TIEMPOS_CONSULTA = 'SET_FINAL_DATE_TIEMPOS_CONSULTA';


const listar = () =>  (dispatch, getStore) => {
    dispatch({type: LOADER_TIEMPOS_CONSULTA, cargando: true});

    const store = getStore();
    const search = store.tiemposConsulta.buscador;
    const filtro = store.tiemposConsulta.filtro;

    const initial_date = store.tiemposConsulta.initial_date;
    const final_date = store.tiemposConsulta.final_date;

    let params = {search, initial_date, final_date};
    if(filtro){
        params[''] = filtro
    }

    api.get("consult/tiempos_consulta", params).then((response) => {
        console.log("Response: ", response)
        dispatch({type: SET_DATA_TIEMPOS_CONSULTA, data: response});
    }).catch((error) => {
        console.log("Error ", error);
    }).finally(()=>{
        dispatch({type: LOADER_TIEMPOS_CONSULTA, cargando: false});
    })
};

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_TIEMPOS_CONSULTA, buscador: search});
    dispatch(listar());
};

const setFinalDate = (value) => (dispatch) => {
    dispatch({type: SET_FINAL_DATE_TIEMPOS_CONSULTA, final_date: value});
    dispatch(listar());
};

const setInitialDate = (value) => (dispatch) => {
    dispatch({type: SET_INICIAL_DATE_TIEMPOS_CONSULTA, initial_date: value});
    dispatch(listar());
};

export const actions = {
    listar,
    search,
    setFinalDate,
    setInitialDate,
};

export const reducer = {
    [LOADER_TIEMPOS_CONSULTA]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_TIEMPOS_CONSULTA]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_TIEMPOS_CONSULTA]: (state, { page }) => {
        return {...state, page }
    },
    [SET_BUSCADOR_TIEMPOS_CONSULTA]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_TIEMPOS_CONSULTA]: (state, { filtro }) => {
        return {...state, filtro }
    },
    [SET_INICIAL_DATE_TIEMPOS_CONSULTA]: (state, { initial_date }) => {
        return{
            ...state,
            initial_date
        }
    },
    [SET_FINAL_DATE_TIEMPOS_CONSULTA]: (state, { final_date }) => {
        return{
            ...state,
            final_date
        }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: [],
    buscador: '',
    filtro: null,

    initial_date: moment().date(1).format("DD/MM/YYYY"),
    final_date: moment().format("DD/MM/YYYY"),
};

export default handleActions(reducer, initialState)
